import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "link-to-page",
  "use": "link-to-page-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"link-to-page\"><path fill-rule=\"evenodd\" d=\"M4 13H1v-2h3v2Zm.004 0H8v2l4-3-4-3v2H4.006l.004-7c0-1.1.89-2 1.99-2h8l6 6v12c0 1.1-.9 2-2 2H5.99C4.89 22 4 21.1 4 20l.004-7ZM13 3.5V9h5.5L13 3.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol